import { useFormik } from 'formik';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';

export const useFormikRegistration = (
  tab: number,
  initEmail: string = '',
  makeRequest: any,
  alignment: string
) => {
  const intl = useIntl();

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      email: Yup.string()
        .email(intl.formatMessage({ id: 'AUTH.INPUT.EMAIL_INCORRECT' }))
        .required(intl.formatMessage({ id: 'PROFILE.VALIDATION.REQUIRED_FIELD' }))
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          intl.formatMessage({ id: 'AUTH.VALIDATION.INVALID_EMAIL' }) // Ошибка если email некорректен
        ),
    });
  }, [tab, intl]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: initEmail,
      fio: '',
      acceptTerms: false,
    },
    validationSchema,
    onSubmit: submitValues => {
      makeRequest('email', {
        ...submitValues,
        role: alignment || 'ROLE_BUYER',
      });
    },
  });

  return formik;
};
